export const tutorialImages = {
  HOME: {
    title: '메인 페이지',
    steps : [
      {name: '', imageUrl: '/assets/tutorial_images/home/home_1.png'},
      {name: '', imageUrl: '/assets/tutorial_images/home/home_2.png'},
      {name: '', imageUrl: '/assets/tutorial_images/home/home_3.png'},
      {name: '', imageUrl: '/assets/tutorial_images/home/home_4.png'},
      {name: '', imageUrl: '/assets/tutorial_images/home/home_5.png'},
      {name: '', imageUrl: '/assets/tutorial_images/home/home_6.png'},
      {name: '', imageUrl: '/assets/tutorial_images/home/home_7.png'},
      {name: '', imageUrl: '/assets/tutorial_images/home/home_8.png'},
    ]
  },
  WORD_DICTIONARY: {
    title: '소통사전',
    steps : [
      {name: '', imageUrl: '/assets/tutorial_images/word_dictionary/word_dictionary_1.png'},
      {name: '', imageUrl: '/assets/tutorial_images/word_dictionary/word_dictionary_2.png'},
      {name: '', imageUrl: '/assets/tutorial_images/word_dictionary/word_dictionary_3.png'},
      {name: '', imageUrl: '/assets/tutorial_images/word_dictionary/word_dictionary_4.png'},
      {name: '', imageUrl: '/assets/tutorial_images/word_dictionary/word_dictionary_5.png'},
      {name: '', imageUrl: '/assets/tutorial_images/word_dictionary/word_dictionary_6.png'},
    ]
  },
  CONVERSATION_NOTE: {
    title: '대화노트',
    steps : [
        {name: '', imageUrl: '/assets/tutorial_images/conversation_note/conversation_note_1.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_note/conversation_note_2.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_note/conversation_note_3.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_note/conversation_note_4.png'},
      ]
  },
  REPORT: {
    title: '분석리포트',
    steps : [
        {name: '', imageUrl: '/assets/tutorial_images/report/report_1.png'},
        {name: '', imageUrl: '/assets/tutorial_images/report/report_2.png'},
        {name: '', imageUrl: '/assets/tutorial_images/report/report_3.png'}
      ]
  },
  WORD_RECORD: {
    title: '아는 단어 기록',
    steps : [
        {name: '', imageUrl: '/assets/tutorial_images/word_record/word_record_1.png'},
        {name: '', imageUrl: '/assets/tutorial_images/word_record/word_record_2.png'},
        {name: '', imageUrl: '/assets/tutorial_images/word_record/word_record_3.png'},
      ]
  },
  WORD_CARD_RECORD: {
    title: '단어 카드 기록',
    steps : [
        {name: '', imageUrl: '/assets/tutorial_images/word_card_record/word_card_record_1.png'},
        {name: '', imageUrl: '/assets/tutorial_images/word_card_record/word_card_record_2.png'},
        {name: '', imageUrl: '/assets/tutorial_images/word_card_record/word_card_record_3.png'},
        {name: '', imageUrl: '/assets/tutorial_images/word_card_record/word_card_record_4.png'},
        {name: '', imageUrl: '/assets/tutorial_images/word_card_record/word_card_record_5.png'},
      ]
  },
  CONVERSATION_RECORD: {
    title: '대화 기록',
    steps : [
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_1.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_2.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_3.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_4.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_5.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_6.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_7.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_8.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_9.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_10.png'},
        {name: '', imageUrl: '/assets/tutorial_images/conversation_record/conversation_record_11.png'},
      ]
  },
  CHILD_VOICE_REGISTER: {
    title: '아이 음성 등록',
    steps : [
        {name: '', imageUrl: '/assets/tutorial_images/child_voice_register/child_voice_register_1.png'},
        {name: '', imageUrl: '/assets/tutorial_images/child_voice_register/child_voice_register_2.png'},
        {name: '', imageUrl: '/assets/tutorial_images/child_voice_register/child_voice_register_3.png'},
        {name: '', imageUrl: '/assets/tutorial_images/child_voice_register/child_voice_register_4.png'},
        {name: '', imageUrl: '/assets/tutorial_images/child_voice_register/child_voice_register_5.png'},
      ]
  },
} 
